import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Instagram, Heart } from "lucide-react";
import { FOOTER } from "@/constants/testIds";

export default function Footer() {
  return (
    <footer className="bg-ink text-cream mt-24 relative overflow-hidden" data-testid={FOOTER.root}>
      <div className="absolute -top-32 -right-32 w-96 h-96 bg-terracotta/15 rounded-full blur-3xl" />
      <div className="absolute -bottom-32 -left-32 w-96 h-96 bg-gold/15 rounded-full blur-3xl" />

      <div className="relative container-edge py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <img src="/brand/logo.jpeg" alt="KNV Travelz" className="h-16 w-16 object-contain rounded-full bg-cream p-1" />
            <div>
              <div className="font-display font-semibold text-2xl tracking-tight text-cream">KNV Travelz</div>
              <div className="font-body text-[11px] uppercase tracking-[0.22em] text-cream/60">Group Tours</div>
            </div>
          </div>
          <p className="hand-accent text-3xl mt-5 text-gold">Let's go somewhere together.</p>
          <p className="mt-5 max-w-md text-sm text-cream/75 leading-relaxed">
            We design <strong className="text-cream">college tours</strong> and <strong className="text-cream">group travel for 25+</strong> —
            the kind of trips that change how students see their future and how groups see the world.
          </p>
          <div className="mt-8 space-y-3 text-sm text-cream/80">
            <a href="mailto:tours@knvtravelz.com" className="flex items-center gap-3 hover:text-gold transition-colors" data-testid="footer-email">
              <Mail size={16} /> tours@knvtravelz.com
            </a>
            <a href="tel:+18622354515" className="flex items-center gap-3 hover:text-gold transition-colors" data-testid="footer-phone">
              <Phone size={16} /> 862-235-4515
            </a>
            <a href="https://www.instagram.com/knvtravelz" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 hover:text-gold transition-colors">
              <Instagram size={16} /> @knvtravelz
            </a>
            <div className="flex items-start gap-3"><MapPin size={16} className="mt-0.5 shrink-0" />
              <span>407 Lincoln Rd, Suite 6H Deck 1690<br />Miami Beach, FL 33139</span>
            </div>
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="font-mono text-[11px] uppercase tracking-[0.24em] text-terracotta mb-5">Explore</div>
          <ul className="space-y-3 text-sm text-cream/85">
            <li><Link to="/college-tours" className="hover:text-gold transition-colors">College Tours</Link></li>
            <li><Link to="/group-travel" className="hover:text-gold transition-colors">Group Travel</Link></li>
            <li><Link to="/past-trips" className="hover:text-gold transition-colors">Past Trips</Link></li>
            <li><Link to="/why-knv" className="hover:text-gold transition-colors">Why KNV</Link></li>
            <li><Link to="/about" className="hover:text-gold transition-colors">About</Link></li>
            <li><Link to="/contact" className="hover:text-gold transition-colors">Contact</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="font-mono text-[11px] uppercase tracking-[0.24em] text-terracotta mb-5">Start a trip</div>
          <p className="text-sm text-cream/75 leading-relaxed mb-5">
            No booking online — every trip starts with a real conversation. Send us your group details and
            we'll be back within two business days with a custom proposal.
          </p>
          <Link to="/request-quote" className="btn-primary text-sm">
            Plan My Trip
          </Link>
        </div>
      </div>

      <div className="relative border-t border-cream/10">
        <div className="container-edge py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-cream/55 font-mono uppercase tracking-[0.2em]">
          <div>© {new Date().getFullYear()} KNV Travelz</div>
          <div className="flex items-center gap-2">Made with <Heart size={12} className="text-terracotta fill-terracotta" /> for educators &amp; groups of 25+</div>
        </div>
      </div>
    </footer>
  );
}
